
  <!-- Content Wrapper. Contains page content -->
  <div class="content-wrapper">
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h1>Gallery</h1>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item"><a href="#">Home</a></li>
              <li class="breadcrumb-item active">Gallery</li>
            </ol>
          </div>
        </div>
      </div><!-- /.container-fluid -->
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
       
        <div class="row">
          <div class="col-12">
            <div class="card card-danger card-outline">
              <div class="card-header">
                <h3 class="card-title">Album Name</h3>

                <div class="card-tools">
                 
                 
                 
                  <button type="button" class="btn btn-tool" title="Back" >
                    <i class="fas fa-arrow-left" ></i>
                  </button>
                </div>
              </div>
                <div class="card-body">
                    <div class="row">
                      <div class="col-sm-2" *ngFor="let img of galimages">
                       <div class="small-box ">
                          <a href="{{img.path}}" data-toggle="lightbox" data-title="{{img.imagetitle}}" data-gallery="gallery" >
                            <img src="{{img.path}}" class="img-fluid mb-2" alt="{{img.imagetitle}}">
                          </a>
                         
                          <a href="{{img.path}}" class="small-box-footer clearfix " download  ><i class="fa fa-cloud-download-alt"></i> Download</a>
                      </div>
                  
                    </div> 
                      <!-- <div class="col-sm-2">
                        <a href="https://via.placeholder.com/1200/000000.png?text=2" data-toggle="lightbox" data-title="sample 2 - black" data-gallery="gallery">
                          <img src="https://via.placeholder.com/300/000000?text=2" class="img-fluid mb-2" alt="black sample">
                        </a>
                      </div> -->
                     
                    </div>
                  </div>
              </div>
          </div>
          <!-- /.col -->
        </div>
        <!-- /.row -->
      </div>
      <!-- /.container-fluid -->
    </section>
    <!-- /.content -->
  </div>
  <!-- /.content-wrapper -->